import { Collapse } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { useRelayEnvironment } from 'react-relay';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { COLOR_SET_LIST_TASK } from '../../const';
import { getKeyCollapse, getObjectFromRelayStoreById } from '../../functions';
import { RootState } from '../../store';
import { ItemTaskType, ItemType, ScheduleItemType } from '../../types';
import DrawerPanelGroupTask from './drawerPanelGroupTask';
import DrawerPanelListTaskEmpty from './drawerPanelListTaskEmpty';
import DrawerPanelTask from './drawerPanelTask';

const StyledCollapse = styled(Collapse).withConfig({
    shouldForwardProp: (prop) => prop !== 'bgColor',
})<{ bgColor?: string }>`
    &.collapse_level_0 > div > .ant-collapse-header {
        background-color: ${(props) => props.bgColor || '#f0f0f0'};
    }
    
    & .ant-collapse-item .ant-collapse-item-active {
        padding: 0;
    }

    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
        padding: 2px 10px;
        margin: 0;
        //margin-bottom: 5px;
        border-radius: 8px;
    }

    //&.collapse_level_0 > div.ant-collapse-item:last-child,
    &.collapse_level_0 > div.ant-collapse-item:last-child > .ant-collapse-header{
        padding: 2px 10px;
        margin: 0;
        border-radius: 8px; !important;
    }
    &.collapse_level_0 .ant-collapse-item >.ant-collapse-content >.ant-collapse-content-box{
        padding-block: 5px;
    }
`;

interface IDrawerPanelListTaskForPeriod {
    listTaskForShow: ItemTaskType[];
    listItemIdForShow: Set<string>;
}

const DrawerPanelListTaskForPeriod: React.FC<IDrawerPanelListTaskForPeriod> = ({
    listTaskForShow,
    listItemIdForShow,
}) => {
    const environment = useRelayEnvironment();
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    const itemsAsProject = itemsList.filter((item) => item.roleItem === 'project');

    const renderResult = itemsAsProject
        .map((item) => {
            const projectItem = getObjectFromRelayStoreById<ScheduleItemType>(environment, item.id);

            const projectListChildrenId =
                projectItem?.children.split(',').filter((itemId) => listItemIdForShow.has(itemId)) || [];

            const getChildrenCollapse = () => {
                if (listTaskForShow.length && projectListChildrenId.length) {
                    return (
                        <DrawerPanelGroupTask
                            key={item.id}
                            childrenIdList={projectListChildrenId}
                            listTaskForShow={listTaskForShow}
                            listItemIdForShow={listItemIdForShow}
                            levelGroup={1}
                        />
                    );
                }

                if (!listTaskForShow.length && !projectListChildrenId.length) {
                    return null;
                }
            };

            const childrenCollapse = getChildrenCollapse();

            const childrenCollapseAndTask = [];

            if (item.tasks.length) {
                childrenCollapseAndTask.push(
                    ...listTaskForShow
                        .filter((task) => task.schedule_item_id === projectItem?.id)
                        .map((task) => <DrawerPanelTask key={task.id} task={task} />),
                );
            }

            if (childrenCollapse) {
                childrenCollapseAndTask.push(childrenCollapse);
            }

            const itemsForCollapseProject = [
                {
                    key: item.id,
                    label: item.name,
                    children: childrenCollapseAndTask.length ? (
                        childrenCollapseAndTask
                    ) : (
                        <DrawerPanelListTaskEmpty key={uuidv4()} />
                    ),
                    forceRender: true,
                },
            ];

            return childrenCollapseAndTask.length ? (
                <StyledCollapse
                    key={item.id}
                    className={'collapse_level_0'}
                    defaultActiveKey={getKeyCollapse(itemsForCollapseProject)}
                    ghost
                    items={itemsForCollapseProject}
                    bgColor={COLOR_SET_LIST_TASK[0]}
                    expandIconPosition={'end'}
                />
            ) : null;
        })
        .filter((element) => element);

    return <>{renderResult.length ? renderResult : <DrawerPanelListTaskEmpty key={uuidv4()} />}</>;
};

export default DrawerPanelListTaskForPeriod;
